import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import GlobalFonts from "./app_fonts";
import { AuthProvider } from "./contexts/Auth/AuthProvider";
import { TokensProvider } from "./contexts/Tokens/TokensProvider";
import { ThemeProvider } from "./contexts/Theme/ThemeContext";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  // <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <TokensProvider>
          <ThemeProvider>
            <GlobalFonts />
            <App />
          </ThemeProvider>
        </TokensProvider>
      </AuthProvider>
    </BrowserRouter>,
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
